import React, { useContext, useState } from "react";
import AppointmentDayPicker from "./AppointmentDayPicker";
import { AppointmentSchedulerContext } from "./AppointmentScheduler";
import AppointmentTimePicker from "./AppointmentTimePicker";

function AppointmentDateTimePicker({ onContinuePressed }) {
  const [selectedDay, setSelectedDay] = useState(new Date());
  const { appointmentType } = useContext(AppointmentSchedulerContext);

  return (
    <div className="appointment-date-time-picker-container">
      <div className="appointment-date-time-picker__title">{`Pick a date and time${
        appointmentType?.name ? ` for your ${appointmentType?.name}.` : ""
      }`}</div>
      <div className="appointment-date-time-picker">
        <AppointmentDayPicker selectedDay={selectedDay} setSelectedDay={setSelectedDay} />
        <AppointmentTimePicker selectedDay={selectedDay} onContinuePressed={onContinuePressed} />
      </div>
    </div>
  );
}

export default AppointmentDateTimePicker;
